<template>
  <!--
      	作者：kmdshop
      	时间：2019-12-25
      	描述：插件中心-文章
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="销售目标" name="target">
                    <Target v-if="activeName=='target'"></Target>
                </el-tab-pane>
            
                <el-tab-pane label="基础设置" name="setting">
                    <Setting v-if="activeName=='setting'"></Setting>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>

    import Target from './target/Index.vue';
    import Setting from './setting/setting.vue';
    export default {
        components: {
            Target,
            Setting
        },
        data() {
            return {
                activeName: 'target',
                /*是否加载完成*/
                loading: true,
            }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/salestarget/index.vue